<script lang="ts">
	import { Slider, Text, Toggle } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { capFirstChar } from '../../../../../../../../../helpers/utilities';
	import { format } from 'svelte-i18n';

	export let actions = []; //both options - select percent level or change roller/cover state
	export let active_actions = []; // because it is only one action we can be sure that active_actions contains only one element
	export let sceneIsValid; // Do not remove this line, it is used in the parent component and its validation

	let sliderInitialValue = actions[0]?.value;

	const dispatch = createEventDispatcher();

	$: value = typeof actions[0]?.value === 'number' ? actions[0].value : 0;
	$: selected = active_actions?.[0]?.name || undefined;

	const handle_checkbox_change = (_ind, e) => {
		if (!e.target.checked) {
			active_actions = [];
			sceneIsValid = false;
		} else {
			let action = actions[_ind];

			switch (action.id) {
				case 'outputLimit':
					active_actions[_ind] = { name: action.id, value: 0 };
					break;
			}
		}

		dispatch('change_active', { new_active: active_actions });
	};

	const handle_slider_changes = (e, act) => {
		console.log('slider event', e);
		value = e.detail.value;
		sliderInitialValue = value !== sliderInitialValue ? value : sliderInitialValue;

		actions[act].value = value;
		active_actions[act] = {
			name: actions[act]?.id,
			value,
		};

		dispatch('change_active', { new_active: active_actions });
	};
	const a11yProps = {
		ariaLabel: $format('label_adjust_value', { default: 'Adjust value' }),
		ariaLabelValue: null,
	};
</script>

{#if actions.length > 0}
	{#each actions as _act, _i}
		<Toggle
			checked={selected === _act.id}
			on:click={(e) => handle_checkbox_change(_i, e)}
			size="l"
			class="mb-s"
			id="toggle-i3v4diu"
		>
			{capFirstChar(
				$format(_act.title, {
					default: _act.title,
				}),
			)}
		</Toggle>

		<Slider
			id="slider-kgka0fe"
			{a11yProps}
			min={0}
			max={1200}
			title={''}
			value={active_actions[_i]?.value}
			type="simple"
			on:value_change={(e) => handle_slider_changes(e, _i)}
			disabled={selected !== _act.id}
		/>
		<Text styleType="body-small" class="d-flex justify-content-center mt-xs text-bold">
			{capFirstChar(
				$format(_act.title, {
					default: _act.title,
				}),
			)}
			{active_actions[_i]?.value || 0}W
		</Text>
	{/each}
{/if}
